import React, { Ref } from 'react'
import { Radio, Typography } from '@dasa-health/components-react'
import { RadioGroup, TextWithButton } from './style'
import { SocialNameModalButton } from '../SocialNameModalButton'
import { useField, useFormikContext } from 'formik'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { useLocation } from 'react-router-dom'

type HasSocialNameRadioType = {
    title?: string
    radioRef?: Ref<HTMLDivElement> | undefined
}

export const HasSocialNameRadio = ({ title, radioRef }: HasSocialNameRadioType) => {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [field, meta, helpers] = useField({ name: 'hasSocialName' })
    const { setFieldValue } = useFormikContext()
    const { dispatchAnalyticsEvent } = useSignUpAnaytics()

    const setEmptyWhenSocialNameFalse = (hasSocialName: boolean) => {
        !hasSocialName && setFieldValue('socialName', '')
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line prefer-destructuring
        const value = e.target.value
        const newValue = value === 'yes'
        setEmptyWhenSocialNameFalse(newValue)
        helpers.setValue(newValue)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { pathname } = useLocation()
        const nameEvent = (pathName: string) => {
            if (pathName === '/recuperar-senha') {
                return 'reset_password'
            }
            return 'cadastro_web'
        }

        dispatchAnalyticsEvent('personalDataOnFieldBlur', {
            name: nameEvent(pathname),
            fieldName: e.target.name,
            errorMessage: meta.error,
        })
    }

    return (
        <RadioGroup className={meta.touched && meta.error ? 'error' : ''} ref={radioRef}>
            <TextWithButton>
                <Typography className="title">{title ? title : 'Você tem um nome social?'}</Typography>
                <SocialNameModalButton />
            </TextWithButton>
            <ul>
                <li>
                    <Radio
                        checked={field.value === true}
                        className={meta.touched && meta.error ? 'error' : ''}
                        label="Sim"
                        name="hasSocialName"
                        onBlur={field.onBlur}
                        onChange={handleChange}
                        value="yes"
                    />
                </li>
                <li>
                    <Radio
                        checked={field.value === false}
                        className={meta.touched && meta.error ? 'error' : ''}
                        label="Não"
                        name="hasSocialName"
                        onBlur={field.onBlur}
                        onChange={handleChange}
                        value="no"
                    />
                </li>
            </ul>
            {meta.touched && meta.error && <span className="error error-message">{meta.error}</span>}
        </RadioGroup>
    )
}
